<div class="sub-section">
  <div class="sub-header">
    <div class="sub-header-data d-flex align-items-center">
      <div class="flex-column header-titles">
        <span class="color-blue fz-18 lh-90" style="margin-bottom: 6px;">
          {{(subscriptionType === 'L' ? 'general.subscription_l' : 'general.subscription_f') | translate}}
        </span>
        <span class="color-blue fz-18 fw-600 lh-90">{{subscriptionCartItem.description}}</span>
        @if (transactionDetails?.subscriptionExpiryDate) {
          <div class="d-flex align-items-center" style="margin-top: 12px;">
            <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.0625 6.77344H6.65947" stroke="#004580" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.51562 4.97656H7.1126" stroke="#004580" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.41797 2.45155L7.84061 0.5" stroke="#004580" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.40625 2.44255L4.87386 0.5" stroke="#004580" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.24609 9.46815H9.39528C9.9753 9.46815 10.4294 8.97801 10.3889 8.39793L9.94382 2.27344" stroke="#004580" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.91195 2.61847L8.39673 8.70251C8.28882 9.15668 7.88417 9.47143 7.41656 9.47143H1.50853C0.829599 9.47143 0.344015 8.80589 0.546345 8.15387L2.43925 2.07439C2.56964 1.6517 2.96081 1.35938 3.40144 1.35938H8.93178C9.35892 1.35938 9.71413 1.62019 9.8625 1.97992C9.94793 2.17328 9.96591 2.39364 9.91195 2.61847Z" stroke="#004580" stroke-miterlimit="10"/>
            </svg>
            <span class="color-blue fz-12" style="line-height: 90%;">
              {{'selling.valid_until' | translate}} {{transactionDetails.subscriptionExpiryDate | localizedDate:'EEEE dd MMMM yyyy'}}
            </span>
          </div>
        }
      </div>
    </div>
    <div class="selected-chart-sections">
      @if (donutChartData) {
        <div class="totals">
          <span class="fractional">
            {{donutChartData[2].value}}/{{transactionDetails?.subscriptionQuantityEnabledEvents}}
          </span>
          <div class="total-details">
            <span class="color-blue bold">{{donutChartData[2].value}}&nbsp;</span>
            <span class="color-blue">{{'selling.subscription_ticket.residues' | translate}}&nbsp;</span>
            <span class="color-blue">{{'general.of' | translate}}&nbsp;</span>
            <span class="color-blue bold">{{transactionDetails?.subscriptionQuantityEnabledEvents}}&nbsp;</span>
            <span class="color-blue">{{'general.total' | translate}}</span>
          </div>
        </div>
      }
    </div>
    @if (totalSelectedSlots > 0) {
      <div class="selected-section">
        <span class="fz-20 fw-600 lh-90 btns-text-label">
          {{'selling.selected' | translate}}: {{totalSelectedSlots}}
        </span>
        <div class="btns">
          <button class="btn-orange orange-shadow" (click)="resetSelection(true)">
            {{ 'general.cancel' | translate | uppercase }}
          </button>
          <button class="btn-outlined-orange btn-apply-loading" (click)="onProceed()" [disabled]="isProceedLoading">
              <span [style.visibility]="isProceedLoading ? 'hidden' : 'visible'" style="color: inherit">{{ 'selling.proceed' | translate | uppercase }}</span>
              @if (isProceedLoading) {
                <div class="loader-inline"></div>
              }
          </button>
        </div>
      </div>
    }
  </div>
  <div class="separator"></div>
  @if (subEventSlots) {
    <div class="slots">
      @if (subEventSlots.length > 1) {
        <div class="main-search">
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.8763 14.84C11.812 14.84 15.0026 11.6859 15.0026 7.79501C15.0026 3.90416 11.812 0.75 7.8763 0.75C3.94055 0.75 0.75 3.90416 0.75 7.79501C0.75 11.6859 3.94055 14.84 7.8763 14.84Z" stroke="#92ADD9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.7503 16.5769L14.25 15.0938" stroke="#92ADD9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <input type="text" class="main-search-input"
            [placeholder]="'selling.subscription_ticket.search_event_location_date' | translate" (keyup)="onFilterEvents($event)">
        </div>
      }
      @for (event of filteredSubEventSlots; track event; let eventIdx = $index) {
        <div class="m-0 pb-20 cart-item">
          <app-curved-header
            [title]="event.eventProgramTitle"
            [color]="event.ticketingTypeColor || '#125896'">
          </app-curved-header>
          <div class="elimina-btn" [id]="'info-' + eventIdx"
            (click)="resetEventSelection(event)">
            <span class="elimina-text">
              {{'selling.delete' | translate}}
            </span>
            <span class="x">×</span>
          </div>
        @if (event.slots.length === 1) {
          <div class="body-cart">
            <div class="cards-details">
              <div class="test">
                <div class="left-items">
                  @if (event.placeCompleteName) {
                    <div class="item-row mobile-margin">
                      <div class="item-wrapper">
                        <span class="card-body-icons location-icon"></span>
                        <span class="items-text">{{event.placeCompleteName}}</span>
                      </div>
                    </div>
                  }
      
                  @if (event.slots[0].formatedDate) {
                    <div class="item-row mobile-margin" [style.width]="event.slots[0].formatedTime ? 'auto' : '55%'">
                      <div class="item-wrapper">
                        <span class="card-body-icons calendar-icon"></span>
                        <span class="text-capitalize items-text">
                          {{ event.slots[0].formatedDate}}
                        </span>
                      </div>
                    </div>
                  }
              
                  @if (event.slots[0].formatedTime) {
                    <div class="item-row">
                      <div class="item-wrapper">
                        <span class="card-body-icons time-icon"></span> 
                        <span class="items-text">{{event.slots[0].formatedTime}} </span>
                      </div>
                    </div>
                  }
                </div>
                <div class="item-row button-row btns-single-case">
                  <div class="item-wrapper">
                    <div class="addButton" (click)="onSetEventSlotNrSelected(event.slots[0], 'decrease')"
                      [disabled]="!event.slots[0].nrSelected > 0" >
                      <img class="rectangle-parent" alt="minus" style="height: 2px;" src="assets/images/icon/svg/minus.svg">
                    </div>
                    <div class="rectangle-group">
                      <div class="mobile-number-input">
                        {{event.slots[0].nrSelected}}
                      </div>
                    </div>
                    <div class="addButton" (click)="onSetEventSlotNrSelected(event.slots[0], 'increase')"
                      [disabled]="disableSelectSlots === true">
                      <img class="rectangle-parent" alt="plus" src="assets/images/icon/svg/plus.svg">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
        }
        @if (event.slots.length > 1) {
          <div class="body-cart no-notches">
            <div class="cards-details with-notches">
              <div class="item-row mobile-margin">
                <div class="item-wrapper">
                  <span class="card-body-icons location-icon"></span>
                  <span class="items-text">{{event.placeCompleteName}}</span>
                </div>
              </div>

              <div class="item-row">
                <div class="item-wrapper">
                  <span class="card-body-icons calendar-icon"></span>
                  <span class="text-capitalize items-text">
                    {{ event.slots[0].formatedDate}}
                  </span>
                </div>
              </div>
              <div class="inline-search">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.8763 14.84C11.812 14.84 15.0026 11.6859 15.0026 7.79501C15.0026 3.90416 11.812 0.75 7.8763 0.75C3.94055 0.75 0.75 3.90416 0.75 7.79501C0.75 11.6859 3.94055 14.84 7.8763 14.84Z" stroke="#CACACA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.7503 15.5769L14.25 14.0938" stroke="#CACACA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input type="text" class="inline-search-input"
                  [placeholder]="'selling.subscription_ticket.search_date' | translate" (keyup)="onFilterEventsSlots($event, eventIdx)">
              </div>

            </div>
            @for (slot of event.filteredSlots; track slot; let slotIdx = $index) {
              <div class="cards-details slot-row dashed-separator-top" [class.first-slot]="slotIdx === 0" @slotAnimation>
                <div class="test">
                  <div class="left-items">
                    <div class="item-row">
                      <div class="item-wrapper">
                        <span class="card-body-icons calendar-icon"></span>
                        <span class="text-capitalize items-text">
                          {{ slot.formatedDate}}
                        </span>
                      </div>
                    </div>
              
                    <div class="item-row">
                      <div class="item-wrapper">
                        <span class="card-body-icons time-icon"></span> 
                        <span class="items-text">{{slot.formatedTime}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="item-row button-row">
                    <div class="item-wrapper">
                      <div class="addButton" (click)="onSetEventSlotNrSelected(slot, 'decrease')"
                        [disabled]="!slot.nrSelected > 0" >
                        <img class="rectangle-parent" alt="minus" style="height: 2px;" src="assets/images/icon/svg/minus.svg">
                      </div>
                      <div class="rectangle-group">
                        <div class="mobile-number-input">
                          {{slot.nrSelected}}
                        </div>
                      </div>
                      <div class="addButton" (click)="onSetEventSlotNrSelected(slot, 'increase')"
                        [disabled]="disableSelectSlots === true">
                        <img class="rectangle-parent" alt="plus" src="assets/images/icon/svg/plus.svg">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      }
    </div>
  }
</div>